// extracted by mini-css-extract-plugin
export default {"countdown":"CountDownTimer_countdown__Not+d"};